export default () => {
  return [
    {
      label: 'Нэр',
      name: 'name',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Зорилго',
      name: 'purpose',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Шаардлага',
      name: 'requirements',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Хэлтэс',
      name: 'departmentid',
      type: 'select',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Албан тушаал',
      name: 'positionid',
      type: 'select',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Ажлын цаг',
      name: 'job_time',
      type: 'date',
      className: 'col-span-6 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Дуусах цаг',
      name: 'end_date',
      type: 'date',
      className: 'col-span-6 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
  ]
}